<form #locationForm="ngForm">
<div class="row p-3">

    <div class="col-6">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="font-weight-bold">Region</label>
            <div class="form-group form-check">
              <input type="checkbox" (change)="selectedLocation={}" name="newregion" [(ngModel)]="isNewRegion" class="form-check-input"
                id="exampleCheck1">
              <label class="form-check-label" for="exampleCheck1">is new region</label>
            </div>
            <div *ngIf="!isNewRegion">
              <p-floatlabel class="w-full md:w-56" variant="on">
                  <p-select (onChange)="loadCampusOptions()" inputId="on_label" [options]="regions" name="region" [(ngModel)]="selectedLocation.region" optionLabel="label" class="w-full" />
                  <label for="on_label">Select a Region</label>
              </p-floatlabel>
            </div>
            <div *ngIf="isNewRegion">
              <input required  [(ngModel)]="selectedLocation.region" name="region" type="text" class="form-control" placeholder="">
              <small id="emailHelp" class="form-text text-muted">Enter a new region.</small>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="font-weight-bold">Campus</label>
            <div *ngIf="!isNewRegion" class="form-group form-check">
              <input type="checkbox" (change)="selectedLocation.campus='';selectedLocation.facility='';selectedLocation.facilityLocation='';selectedLocation.functionalArea='';" name="newcampus" [(ngModel)]="isNewCampus" class="form-check-input"
                id="exampleCheck1">
              <label class="form-check-label" for="exampleCheck1">is new campus</label>
            </div>
            <div *ngIf="!isNewCampus && !isNewRegion;else newCampus">
              <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select (onChange)="loadFacilityOptions()" inputId="campus_label" [options]="campuses" name="campus" [(ngModel)]="selectedLocation.campus" optionLabel="label" class="w-full" />
                <label for="campus_label">Select a Campus</label>
              </p-floatlabel>
            </div>
            <ng-template #newCampus>
              <input required  [(ngModel)]="selectedLocation.campus" name="campus" type="text" class="form-control" placeholder="">
              <small id="emailHelp" class="form-text text-muted">Enter a new campus.</small>
            </ng-template>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="font-weight-bold">Facility</label>
            <div *ngIf="!isNewRegion && !isNewCampus" class="form-group form-check">
              <input type="checkbox" (change)="selectedLocation.facility='';selectedLocation.facilityLocation='';selectedLocation.functionalArea='';" name="newfacility" [(ngModel)]="isNewFacility"
                class="form-check-input" id="exampleCheck1">
              <label class="form-check-label" for="exampleCheck1">is new facility</label>
            </div>
            <div *ngIf="!isNewFacility && !isNewCampus && !isNewRegion; else newFacility">
                <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select (onChange)="loadLocationOptions()" inputId="facility_label" [options]="facilities" name="facility" [(ngModel)]="selectedLocation.facility" optionLabel="label" class="w-full" />
                <label for="facility_label">Select a Facility</label>
              </p-floatlabel>
            </div>
            <ng-template #newFacility>
              <input required  [(ngModel)]="selectedLocation.facility" name="facility" type="text" class="form-control" placeholder="">
              <small id="emailHelp" class="form-text text-muted">Enter a new facility.</small>
            </ng-template>
          </div>
        </div>

      </div>
    </div>
    <div class="col-6">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="font-weight-bold">Location</label>
            <div *ngIf="!isNewRegion && !isNewCampus && !isNewFacility" class="form-group form-check">
              <input type="checkbox" (change)="selectedLocation.facilityLocation='';selectedLocation.functionalArea='';" name="newFacilityLocation" [(ngModel)]="isNewFacilityLocation"
                class="form-check-input" id="exampleCheck1">
              <label class="form-check-label" for="exampleCheck1">is new stock area</label>
            </div>
            <div
              *ngIf="!isNewFacilityLocation && !isNewFacility && !isNewCampus && !isNewRegion; else newFacilityLocation">
              <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select (onChange)="loadFunctionalAreaOptions()" inputId="facilityLocation_label" [options]="facilityLocations" name="facilityLocation" [(ngModel)]="selectedLocation.facilityLocation" optionLabel="label" class="w-full" />
                <label for="facilityLocation_label">Select a Stock Area</label>
              </p-floatlabel>
              <small id="emailHelp" class="form-text text-muted">Select a stock area.</small>
            </div>
            <ng-template #newFacilityLocation>
              <input required  [(ngModel)]="selectedLocation.facilityLocation" type="text" name="facilityLocation" class="form-control" placeholder="">
              <small id="emailHelp" class="form-text text-muted">Enter a new location.</small>
            </ng-template>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="font-weight-bold">Functional Area</label>
            <div *ngIf="!isNewRegion && !isNewCampus && !isNewFacility && !isNewFacilityLocation" class="form-group form-check">
              <input type="checkbox" (change)="selectedLocation.functionalArea=''" name="newfunctionalArea" [(ngModel)]="isNewFunctionalArea"
                class="form-check-input" id="exampleCheck1">
              <label class="form-check-label" for="exampleCheck1">is new funcitonal area</label>
            </div>
            <div
              *ngIf="!isNewFunctionalArea && !isNewFacilityLocation && !isNewFacility && !isNewCampus && !isNewRegion; else newFuntionalArea">
              <p-floatlabel class="w-full md:w-56" variant="on">
                <p-select required  inputId="functionalArea_label" [options]="functionalAreas" name="functionalArea" [(ngModel)]="selectedLocation.functionalArea" optionLabel="label" class="w-full" />
                <label for="functionalArea_label">Select a Functional Area</label>
              </p-floatlabel>
              <small id="emailHelp" class="form-text text-muted">Select a Functional Area.</small>
            </div>
            <ng-template #newFuntionalArea>
              <input required  [(ngModel)]="selectedLocation.functionalArea" name="functionalArea" type="text" class="form-control" placeholder="">
              <small id="emailHelp" class="form-text text-muted">Enter a new Functional Area.</small>
            </ng-template>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="font-weight-bold">Location Prefix</label>
            <input required  [(ngModel)]="selectedLocation.prefix" name="prefix" type="text" class="form-control" placeholder="">
            <small id="emailHelp" class="form-text text-muted">Enter a prefix for this Stock Area.</small>
          </div>
        </div>
        <div class="col-12 text-right pb-5">
          <p-button label="Reset" (click)="reset()"></p-button>
          <p-button [disabled]="!locationForm.valid" label="Save" class="ml-3"></p-button>
        </div>
      </div>
    </div>

</div>
</form>
